import { Quote, QuoteStatus, QuotesState } from "../types";

export const mockQuotes: Quote[] = [
  {
    id: "1",
    quoteNumber: "Q-8091",
    createdAt: "2026-03-10",
    customerNameKey: "QUOTES.MOCK.CUSTOMER.GALON",
    projectTypeKey: "QUOTES.MOCK.PROJECT.MARCH_10",
    revisionNumber: 1,
    totalValue: 66600,
    status: QuoteStatus.DRAFT,
    validUntil: "2026-04-10",
    descriptionKey: "QUOTES.MOCK.DESCRIPTION.Q_8091",
  },
  {
    id: "2",
    quoteNumber: "Q-8092",
    createdAt: "2026-03-10",
    customerNameKey: "QUOTES.MOCK.CUSTOMER.GALON",
    projectTypeKey: "QUOTES.MOCK.PROJECT.HEAVY_TIPPER",
    revisionNumber: 2,
    totalValue: 66600,
    status: QuoteStatus.SENT,
    validUntil: "2026-04-10",
    descriptionKey: "QUOTES.MOCK.DESCRIPTION.Q_8092",
  },
  {
    id: "3",
    quoteNumber: "Q-8094",
    createdAt: "2026-03-10",
    customerNameKey: "QUOTES.MOCK.CUSTOMER.GALON",
    projectTypeKey: "QUOTES.MOCK.PROJECT.CUSTOM_OPEN_BODY",
    revisionNumber: 1,
    totalValue: 66600,
    status: QuoteStatus.ACCEPTED,
    validUntil: "2026-04-10",
    descriptionKey: "QUOTES.MOCK.DESCRIPTION.Q_8094",
  },
];

export const initialState: QuotesState = {
  list: mockQuotes,
  selectedQuote: null,
  quoteDetails: null,
  quotationForm: null,
  boxStructure: null,
  accessories: null,
  loading: false,
  detailLoading: false,
  error: null,
  search: "",
  statusFilter: [
    "ALL",
    QuoteStatus.DRAFT,
    QuoteStatus.SENT,
    QuoteStatus.ACCEPTED,
  ],
};
